











import Vue from "vue";
export default Vue.extend({
  name: "Navbar",
  props: {
    title: {
      type: String,
      required: true
    }
  }
});
